import { render } from "./TotalStudent.vue?vue&type=template&id=b6810db4"
import script from "./TotalStudent.vue?vue&type=script&lang=js"
export * from "./TotalStudent.vue?vue&type=script&lang=js"

import "./TotalStudent.vue?vue&type=style&index=0&id=b6810db4&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__